import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import Highlight from 'components/utils/highlight';

export default class Token extends Component {
    static propTypes = {
        token: ImmutablePropTypes.map.isRequired,
        highlightByTime: PropTypes.bool.isRequired,
        addSpace: PropTypes.bool,
        showSearchResults: PropTypes.bool,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        addSpace: false,
        showSearchResults: false,
        onClick: null,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.token !== this.props.token ||
            nextProps.highlightByTime !== this.props.highlightByTime;
    }

    @autobind
    handleClick() {
        if (this.props.onClick) this.props.onClick(this.props.token);
    }

    render() {
        const {
            token,
            addSpace,
            highlightByTime,
            showSearchResults,
        } = this.props;

        const filteredDisplayAs = (word, space) => {
            const censor = '****';
            const profanityList = ['ass', 'asses', 'asshole', 'assholes', 'asskisser',
                'asswipe', 'bitch', 'bitcher', 'bitchers', 'bitches', 'bitchin', 'bitching', 'blowjob',
                'blowjobs', 'boner', 'bullshit', 'butt', 'buttface', 'buttfuck', 'buttfucker', 'butthead',
                'butthole', 'buttpicker', 'chink', 'clit', 'cobia', 'cock', 'cocks', 'cocksuck', 'cocksucked',
                'cocksucker', 'cocksucking', 'cocksucks', 'cooter', 'cum', 'cummer', 'cumming', 'cums', 'cumshot',
                'cunilingus', 'cunillingus', 'cunnilingus', 'cunt', 'cuntlick', 'cuntlicker', 'cuntlicking',
                'cunts', 'cyberfuc', 'cyberfuck', 'cyberfucked', 'cyberfucker', 'cyberfuckers',
                'cyberfucking', 'dick', 'dike', 'dildo', 'dildos', 'dink', 'dinks', 'dipshit',
                'dong', 'dumbass', 'dyke', 'fag', 'fagget', 'fagging', 'faggit', 'faggot',
                'faggs', 'fagot', 'fagots', 'fags', 'fatass', 'fatso', 'felatio', 'fellatio',
                'fingerfuck', 'fingerfucked', 'fingerfucker', 'fingerfuckers', 'fingerfucking',
                'fingerfucks', 'fistfuck', 'fistfucked', 'fistfucker', 'fistfuckers', 'fistfucking',
                'fistfuckings', 'fistfucks', 'fuck', 'fucked', 'fucker', 'fuckers', 'fuckin', 'fucking',
                'fuckings', 'fuckme', 'fucks', 'fuk', 'fuks', 'furburger', 'gangbang', 'gangbanged',
                'gangbangs', 'gaysex', 'gazongers', 'goddamn', 'gonads', 'gook', 'guinne', 'hardcoresex',
                'hooker', 'horniest', 'horny', 'hotsex', 'hussy', 'jackass', 'jackoff', 'jack-off', 'jap',
                'jerk-off', 'jism', 'jiz', 'jizm', 'jizz', 'kike', 'kock', 'kondum', 'kondums', 'kraut',
                'kum', 'kummer', 'kumming', 'kums', 'kunilingus', 'merde', 'mick', 'micropenis', 'mothafuck',
                'mothafucka', 'mothafuckas', 'mothafuckaz', 'mothafucked', 'mothafucker', 'mothafuckers',
                'mothafuckin', 'mothafucking', 'mothafuckings', 'mothafucks', 'motherfuck', 'motherfucked',
                'motherfucker', 'motherfuckers', 'motherfuckin', 'motherfucking', 'motherfuckings',
                'motherfucks', 'muff', 'nigga', 'niggas', 'nigger', 'niggers', 'pecker', 'penis', 'phonesex',
                'phuk', 'phuked', 'phuking', 'phukked', 'phukking', 'phuks', 'phuq', 'pimp', 'pussies',
                'pussy', 'pussys', 'retard', 'schlong', 'screw', 'sheister', 'shit', 'shited', 'shitfull',
                'shiting', 'shitings', 'shits', 'shitted', 'shitter', 'shitters', 'shitting', 'shittings',
                'shitty', 'slag', 'slut', 'sluts', 'smut', 'snatch', 'spunk', 'twat', 'wetback', 'whore', 'wop'];
            const displayValue = word.get('displayAs');
            let filteredToken = '';
            if (profanityList.indexOf(displayValue) !== -1) {
                filteredToken = censor + (space ? ' ' : '');
            } else {
                filteredToken = displayValue + (space ? ' ' : '');
            }
            return filteredToken;
        };

        const displayAs = filteredDisplayAs(token, addSpace);

        let range = token.getIn(['highlight', 'range']);
        range = range ? range.toJS() : [];

        const className = classNames('cielo24-vwrap-token', {
            'cielo24-vwrap-highlight-time': highlightByTime && token.getIn(['highlight', 'time']),
            'cielo24-vwrap-highlight-result': showSearchResults && token.getIn(['highlight', 'result']),
            'cielo24-vwrap-highlight-active-result': showSearchResults && token.getIn(['highlight', 'activeResult']),
        });

        return (
            <Highlight
                value={displayAs}
                range={range}
                className={className}
                onClick={this.handleClick}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/transcript/token.js